<template>
  <div class="selector">
   <ul >
     <li v-for="lan in $store.state.languages" @click="selectLang(lan.value)">
       {{lan.label}}
     </li>
   </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lang: null,
    };
  },

  computed: {
    languages() {
      return this.$store.state.languages;
    },

    fallback_lang() {
      return this.$store.state.fallback_lang;
    },
  },

  methods: {

    selectLang(lang) {
      this.$store.commit("set_app_loading", true);

      var vue = this;

      axios({
        method: "post",
        url: window.location.origin + "/set-language",
        data: {
          lang: lang,
        },
      })
        .then((res) => {
           console.log(res.data)
          //window.location.reload();
        })
        .catch(() => {
          //this.$store.commit("set_app_loading", false);
        }).finally(() => {
        window.location.reload();
      });
    },
  },

  mounted() {
    this.lang = this.$store.state.current_lang
      ? this.$store.state.current_lang
      : this.$store.state.fallback_lang;
  },
};
</script>

<style scoped>
.selector {
  width: 100%;
  max-width: 80px;
}
.selector >>> .vs__search {
  opacity: 0;
}
.selector >>> .vs__dropdown-toggle {
  border: none;
  padding: 0;
}
.selector >>> .vs__selected {
  color: white;
  margin: 0;
  position: relative;
  padding: 0;
}
.selector >>> .vs__selected-options {
  padding: 0;
}
.selector >>> .vs__actions {
  padding: 0;
}
.selector >>> .vs__open-indicator {
  fill: white;
  transform: scale(0.6);
}
.selector >>> .vs__search {
  margin: 0;
}
.selector >>> .vs__dropdown-menu {
  min-width: 20px;
  background-color: white;

  border: none;
}
.selector >>> .vs__dropdown-option {
  margin: 0 !important;
  padding: 10px;
  color: var(--black);
}
.selector >>> .vs__dropdown-option--highlight {
  background-color: var(--dark-gray);
  color: white;
}
.selector ul li {
  text-transform: uppercase;
  cursor: pointer;
  padding: 20px 20px;
}
.selector ul li:hover {
  background-color: #5f5f6e;
}
</style>
